// ----------------------------------------------------------------------

const account = {
  displayName: "Local Vocal ",
  email: "Localvocalbusinessgroup@minimals.cc",
  photoURL: "/static/mock-images/avatars/avatar_default.jpg"
};

export default account;
